<template>
  <div class="jobDetail breadcrumbs-absolute aboutUs resourceLibrary" :class="{'aboutUsPC':$store.state.innerWidth>768}">
    <div class="header jobPosingSearch row flexHeader flexHeaderJia200">
    <Breadcrumbs></Breadcrumbs>
        <div class="warp-mask"></div>
        <div class="job-containers-center col-sm-10 col-md-8 padLeft-0 padRight-0">
            <h1 class="Bold" :class="{'font-size-60':$store.state.innerWidth>768}"> {{$t('message.Resources')}}</h1>
        </div>
    </div>
    <div class="opp-contain row">
      <div class="opportunityPC  marin-b2-100" style="z-index:1;">
        <div class="descriptionPC-left col-sm-4 col-md-4 padLeft-0 padRight-0 ">
            <i class="icon-arrow-down mainColor" :class="{'arrow-down-rotate':showMenuGroup}" @click="openMenuGroup"></i>
            <div class="row menuLeft showSelect"  @click="openMenuGroup">
              <div  v-if="selectId==resourceGroup.id" v-for="(resourceGroup,index) in resourceGroupList">
                {{$store.getters.getObject(resourceGroup.langData).name}}
              </div>
            </div>
            <div class="menuGroup"  :class="{'SemiBold':$store.state.innerWidth>768}" v-if="showMenuGroup||$store.state.innerWidth>768">
              <div class="row menuLeft" @click="selectEvent(resourceGroup)" :class="{'selectMenu':selectId==resourceGroup.id}" v-for="(resourceGroup,index) in resourceGroupList">
                <a href="javascript:;" style="color: inherit">{{$store.getters.getObject(resourceGroup.langData).name}}</a>
              </div>
            </div>
        </div>
        <div class="mask" @click="openMenuGroup" :class="{'show':showMenuGroup,'maskPC':$store.state.innerWidth>768}"></div>
        <div class="descriptionPC-right col-sm-8 col-md-8 padLeft-0 padRight-0" >
            <div class="contentGroup padding-b-50">
               <img class="bgImg2 noSelect" v-if="$store.state.innerWidth<=1320" src="../images/deco-18.png" />
               <div class="page1 row" >
                 <h2 class="Bold">{{$store.getters.getObject(selectItem.langData).name}} <img class="titleBg1" src="../images/deco-16.png" /></h2>
                 <div class=" resource-link" v-for="(resourceLink,index) in resourceLinkList.resources">
                   <a target="_blank"
                      v-bind:href="$store.getters.getObject(resourceLink.langData).url">
                     {{$store.getters.getObject(resourceLink.langData).name}}
                   </a>
                 </div>
                 <div v-for="subcategory in resourceLinkList.subcategoryResources">
                    <h3 class="SemiBold">{{$store.getters.getObject(subcategory.subcategoryLangData).name}}</h3>
                     <div class=" resource-link" v-for="(resource,index) in subcategory.resources">
                      <a target="_blank"
                         v-bind:href="$store.getters.getObject(resource.langData).url">
                        {{$store.getters.getObject(resource.langData).name}}
                      </a>
                    </div>
                 </div>
               </div>
            </div>
        </div>
      </div>
      <img class="bgImg noSelect" v-if="$store.state.innerWidth>1320" src="../images/deco-18.png" />
    </div>

  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";

export default {
  name:"resources",
  data() {
    return {
      selectId:1,
      selectItem:{},
      showMenuGroup:false,
      resourceGroupList:[],
      resourceLinkList:{
        resources:[],
        subcategoryResources:[]
      },
        }
    },   
  props:[
    "logGaEvent"
  ],
  components: {
    Breadcrumbs,
  },
    computed:{
  
    innerwidth(){
      return this.$store.state.innerWidth;
    },
  
  },
  created() {},
  methods: {
     
    selectEvent:function(item){
      this.selectId = item.id;
      this.selectItem = item;
      this.showMenuGroup = false;
      this.resourceLinkList = [];
      this.getResourceLinkList();
    },
    openMenuGroup:function(){
      this.showMenuGroup = !this.showMenuGroup;
    },
    getResourceGroupList:function(){
      var that = this;
      this.api.getResourceGroupList({
        "startRow":0,
        "maxRows":20000
      }, function(data) {
          that.$set(that, "resourceGroupList", data.result);
          that.selectId = data.result[0].id;
          that.selectItem = data.result[0];
          that.getResourceLinkList();
      })
    },
    getResourceLinkList:function(){
      var that = this;
      this.api.getResourceLinkList({
        "startRow":0,
        "maxRows":20000,
        "resourceGroupId":that.selectId
      }, function(data) {
          that.$set(that, "resourceLinkList", data.result);
      })
    },
  },
  mounted() {
    var that = this;
    setTimeout(function(){
      that.$store.state.mate.title = that.$i18n.t("message.Resources")+' - talent.gov.hk - '+that.$i18n.t("message.Default Page Title");
    })
    this.getResourceGroupList();
        // this.$store.state.mate.title = this.$i18n.t("message.Resources")+" - talent.gov.hk - "+this.$i18n.t("message.Default Page Title")
    this.$store.state.selectMenu = 0;
  },
   watch:{
    innerwidth (news,old) {
     
    },
  }
};
</script>